import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import {
  TableHeader,
  SearchInput,
  IconButtonDatatable,
  DatatablesFooterServerSide,
  Loading,
} from "App/Component/ui";
import { headCells, ModalBarang, STYLE_WMS_PO } from "./helpers";

import { defaultToastError, formatNumber } from "App/utils/helpers";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { SelectIcon } from "App/Assets";
import { useContext } from "react";
import { FormContext } from "../../context/FormContext";
import {
  getByFilterBarang,
  RESET_STATE_FORM_FILTER,
} from "../../../../Master/MasterBarang/ui";

export default function DataBarang({
  formBarang,
  setFormBarang,
  showModalBarang,
  setShowModalBarang,
  setNewDataPoList,
  setListPO,
  listPO,
}) {
  const classes = STYLE_WMS_PO();
  const { formData } = useContext(FormContext);
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  useEffect(() => {
    (async () => {
      await setNewDataBarang();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataBarang = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);
    const res = await getByFilterBarang(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataBarang });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewDataBarang();
  };

  const handleClickSelectBarang = (row) => {
        const barang = listPO;
        const checkBarang = barang.filter(
          (e) => e.barang_id === row.id
        );
        if (checkBarang.length === 0) {
          setShowModalBarang(!showModalBarang);
          setFormBarang({
            // po_id: formData?.idpo,
            id: null,
            namabarang: row?.name,
            namasatuan:row?.satuan_beli,
            satuan_id: row?.satuanbeli_id,
            barang_id: row?.id,
            qty: 1,
            harga: row?.hargabeli,
            harga2: formatNumber(row?.hargabeli),
            disc: 0,
            remark: "",
            statUpdate: false,
          });
        }else{
           defaultToastError("Tidak dapat memilih barang yang sama !");
        }
   
  };

  return (
    <>
      {showModalBarang && (
        <ModalBarang
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewDataPoList={setNewDataPoList}
          setListPO={setListPO}
          listPO={listPO}
        />
      )}

      <div className={classes.header}>
        <div>
          <p className='fw-600 mb-1 mt-1'>Data Barang</p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "0 10px",
          }}>
          <form onSubmit={(e) => handleSubmit(e)}>
            <SearchInput
              withIcon={true}
              onchange={(e) => {
                setFormFilter({
                  ...formFilter,
                  nama: e.target.value,
                });
              }}
            />
          </form>
        </div>
      </div>
      <Loading show={loading} />
      <TableDaftarBarang
        rows={rows}
        classes={classes}
        formData={formData}
        handleClickSelectBarang={handleClickSelectBarang}
      />
      <DatatablesFooterServerSide
        totalData={totalData}
        pagination={pagination}
        handleChangeLimit={handleChangeLimit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentPage={pagination.page}
        handleClickPageNumber={handleClickPageNumber}
      />
    </>
  );
}

const RenderTableCell = ({ row }) => {
  return (
    <>
      <TableCell align='left'>{row.name}</TableCell>
      <TableCell align='left'>{row.satuan_beli}</TableCell>
      <TableCell align='left'>{row.qjb}</TableCell>
      <TableCell align='right'>{formatNumber(row?.hargabeli)}</TableCell>
    </>
  );
};

const TableDaftarBarang = ({
  rows,
  classes,
  handleClickSelectBarang,
  formData,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });
  return (
    <TableContainer
      className='custom-scrollbar'
      style={{
        maxHeight: "300px",
      }}>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {rows.map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <IconButtonDatatable
                    onClick={() => {
                      if (
                        formData.isProcess === false
                      ) {
                        handleClickSelectBarang(row);
                      } else {
                        return;
                      }
                    }}>
                    <SelectIcon />
                  </IconButtonDatatable>
                </TableCell>
                <RenderTableCell row={row} />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
